export default __webpack_public_path__ + "0d1b437bf3d52f3636168f59fbb04f66.png";